import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { checkConsentRefresh } from './api'
import { ConsentRefreshScreen } from './ConsentRefreshScreen'

export function ConsentRefreshGate2026({ children }: { children: ReactNode }) {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['consent-refresh-2026'],
    queryFn: checkConsentRefresh,
    staleTime: 0,
  })

  // Fail open on load/error so a check hiccup never bricks the app; gate is self-extinguishing.
  if (isLoading || isError) return <>{children}</>
  if (data?.pending) {
    return (
      <ConsentRefreshScreen
        records={data.records}
        language={data.language}
        onDone={() => refetch()}
      />
    )
  }
  return <>{children}</>
}
